import ChapelsCheckbox from '../layout/Admin/reports/ChapelsCheckbox'
import useReport from '../../hooks/actions/useReport'

export default function ChapelReportList() {

    const { simplifiedChapels } = useReport();

    return (
        <div className='w-full'>
            <label className="block text-xs font-medium text-gray-700 mb-1">Chapels</label>
            <div className={`grid grid-cols-3 md:grid-cols-5 lg:grid-cols-7 gap-2`}>
                {simplifiedChapels.map((chapel) => {
                    return (
                        <ChapelsCheckbox key={chapel.chapelID} chapel={chapel} />
                    )
                })}
            </div>
        </div>
    )
}
